module.exports = __webpack_public_path__ + "static/media/original-empty.1d2ca11e.png";